<div class="searching-form">
    <div class="container default-container">
        <div class="advanced-search-items">
            <!-- row 2 -->
            <div class="row form-row">
                <!-- name -->
                <div class="row col-sm-6 col-md info order-type">
                    <div class="label col-auto"><span>구매자명</span></div>
                    <input class="col" type="text" id="rName" [(ngModel)]="rName">
                </div>

                <!-- mobile -->
                <div class="row col-sm-6 col-md info order-path">
                    <div class="label col-auto"><span>핸드폰번호</span></div>
                    <input class="col" type="text" id="rMobile" [(ngModel)]="rMobile">
                </div>
                <!-- Submit Btn -->
                <div class="col-md-auto submit-btn-wrapper">
                    <div class="w-btn submit-btn has-icon advanced" id="search-btn" (click)="search.emit();">
                        <span>검색</span>
                        <div class="icon"><img src="./assets/img/icons/search-ncc.svg"></div>
                    </div>
                </div>
            </div>
        </div>

        <!-- btns mobile -->
        <date-time-filter-mobile></date-time-filter-mobile>
    </div>
</div>